import { registerPlugin } from '@capacitor/core';

export interface AudioMergePlugin {
  /**
   * Merge multiple audio files into a single AAC/MP4 file using ffmpeg-kit.
   * Android only — used in the S3 upload path (buildUploadBlob in useAudioSyncService)
   * to produce a single valid container before upload. This prevents AWS transcoder
   * from truncating at the first WebM EOF marker when sessions are naively concatenated.
   *
   * @param options.inputPaths - Array of file:/// URIs to merge in order
   * @param options.outputPath - file:/// URI for the merged output file
   */
  mergeFiles(options: {
    inputPaths: string[];
    outputPath: string;
  }): Promise<{ success: boolean; outputPath: string; duration: number }>;
}

export const AudioMerge = registerPlugin<AudioMergePlugin>('AudioMerge', {
  // Web/iOS no-op fallback
  web: () =>
    Promise.resolve({
      mergeFiles: () =>
        Promise.resolve({ success: false, outputPath: '', duration: 0 }),
    }),
});
